if (!window.customElements.get('custom-promo-bar')) {
  function getFlickity() {
    if (window.theme && window.theme.Flickity) {
      return window.theme.Flickity;
    }
    return window.Flickity || null;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setStickyPromoBarHeight() {
    var stickyPromoBar = document.querySelector('[data-sticky-promo-bar]');

    if (!stickyPromoBar) {
      document.documentElement.style.removeProperty('--custom-promo-bar-height');
      return;
    }

    var height = Math.ceil(stickyPromoBar.getBoundingClientRect().height || stickyPromoBar.offsetHeight || 0);
    document.documentElement.style.setProperty('--custom-promo-bar-height', height + 'px');
  }

  function setAnnouncementHeight() {
    var bars = document.querySelectorAll('[data-announcement-bar]');
    var height = 0;

    bars.forEach(function (bar) {
      height += Math.ceil(bar.getBoundingClientRect().height || bar.offsetHeight || 0);
    });

    document.documentElement.style.setProperty('--announcement-height', height + 'px');

    setStickyPromoBarHeight();

    if (window.theme && typeof window.theme.setVars === 'function') {
      window.theme.setVars();
    }
  }

  function bindCloseButton(promoBar) {
    var closeButton = promoBar.querySelector('[data-promo-close]');

    if (!closeButton) {
      return;
    }

    closeButton.addEventListener('click', function () {
      var carousel = promoBar.querySelector('[data-promo-carousel]');
      var Flickity = carousel ? getFlickity() : null;
      var flickity = Flickity && typeof Flickity.data === 'function' ? Flickity.data(carousel) : null;

      pauseCarousel(flickity);
      promoBar.hidden = true;
      setAnnouncementHeight();
    });
  }

  function bindCarouselColors(promoBar, flickity) {
    function applyColors() {
      var selectedElement = flickity.selectedElement;

      if (!selectedElement) {
        return;
      }

      promoBar.style.setProperty('--promo-bar-bg', selectedElement.dataset.bg || '');
      promoBar.style.setProperty('--promo-bar-text', selectedElement.dataset.color || '');
    }

    applyColors();
    flickity.on('change', applyColors);
  }

  function pauseCarousel(flickity) {
    if (flickity && typeof flickity.pausePlayer === 'function') {
      flickity.pausePlayer();
    }
  }

  function resumeCarousel(flickity) {
    if (!flickity || !flickity.options.autoPlay) {
      return;
    }

    if (typeof flickity.unpausePlayer === 'function') {
      flickity.unpausePlayer();
    } else if (typeof flickity.playPlayer === 'function') {
      flickity.playPlayer();
    }
  }

  function bindCarouselPause(carousel, flickity) {
    if (!flickity || !flickity.options.autoPlay) {
      return;
    }

    carousel.addEventListener('mouseenter', function () {
      pauseCarousel(flickity);
    });

    carousel.addEventListener('mouseleave', function () {
      if (!carousel.contains(document.activeElement)) {
        resumeCarousel(flickity);
      }
    });

    carousel.addEventListener('focusin', function () {
      pauseCarousel(flickity);
    });

    carousel.addEventListener('focusout', function (event) {
      if (event.relatedTarget && carousel.contains(event.relatedTarget)) {
        return;
      }

      if (!carousel.matches(':hover')) {
        resumeCarousel(flickity);
      }
    });
  }

  function bindMarqueePause(promoBar) {
    var inner = promoBar.querySelector('[data-promo-inner]');

    if (!inner || !promoBar.classList.contains('custom-promo-bar--marquee')) {
      return;
    }

    promoBar.addEventListener('focusin', function () {
      inner.classList.add('is-paused');
    });

    promoBar.addEventListener('focusout', function (event) {
      if (!event.relatedTarget || !promoBar.contains(event.relatedTarget)) {
        inner.classList.remove('is-paused');
      }
    });
  }

  function initCarousel(promoBar, carousel) {
    var attempts = 0;
    var autoplay = parseInt(carousel.getAttribute('data-autoplay'), 10);

    if (Number.isNaN(autoplay) || prefersReducedMotion()) {
      autoplay = false;
    }

    function waitForFlickity() {
      var Flickity = getFlickity();

      attempts += 1;

      if (!Flickity) {
        if (attempts < 60) {
          window.setTimeout(waitForFlickity, 100);
        }
        return;
      }

      var existing = typeof Flickity.data === 'function' ? Flickity.data(carousel) : null;
      var flickity = existing || new Flickity(carousel, {
        adaptiveHeight: false,
        autoPlay: autoplay,
        cellAlign: 'center',
        cellSelector: '.carousel__slide',
        pageDots: false,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
        wrapAround: true,
        on: {
          ready: setAnnouncementHeight,
          change: setAnnouncementHeight
        }
      });

      if (carousel.classList.contains('custom-promo-bar--use-colors-true')) {
        bindCarouselColors(promoBar, flickity);
      }

      bindCarouselPause(carousel, flickity);
      setAnnouncementHeight();
    }

    waitForFlickity();
  }

  function initPromoBar(promoBar) {
    if (!promoBar || promoBar.dataset.promoBarInitialized === 'true') {
      return;
    }

    promoBar.dataset.promoBarInitialized = 'true';

    var carousel = promoBar.querySelector('[data-promo-carousel]');

    if (carousel) {
      initCarousel(promoBar, carousel);
    } else {
      setAnnouncementHeight();
    }

    bindMarqueePause(promoBar);
    bindCloseButton(promoBar);
  }

  function initPromoBars(root) {
    root.querySelectorAll('[data-custom-promo-bar]').forEach(initPromoBar);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPromoBars(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initPromoBars(event.target);
  });

  window.addEventListener('resize', setAnnouncementHeight);

  class CustomPromoBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      initPromoBar(this);
    }
  }

  window.customElements.define('custom-promo-bar', CustomPromoBar);
}
